import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const groupsModURL = "api/v1/products-app/groups";
//obtaining the paginated data
export const getGroups = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${groupsModURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllGroups = () => axiosInstance.get(`${groupsModURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageGroups = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${groupsModURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

//creating function
export const createGroups = (body) => axiosInstance.post(`${groupsModURL}/create`, body);
//updating function
export const updateGroups = (id, body) => axiosInstance.patch(`${groupsModURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ search, rowsPerPage, sortOrder }) =>
  axiosInstance.get(`${groupsModURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`);

// checking the redundant data
export const checkRedundantDataGroupsName = (e, cancelToken) =>
  axiosInstance.get(`${groupsModURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
